import React, { useEffect, useState } from 'react';

import { useInView } from 'react-intersection-observer';
import { IDoctor } from '@/schemas/operation';
import { isInApp, toLogin, sendShow, sendClick } from '@/utils/helpers';
import ksBridge from '@ks/ks-bridge';
import openOrDownload from '@utils/open-or-download-url';
import Toast from '@components/Toast';
import WebImage from '@/components/WebImage';
import styles from './index.module.scss';

interface IDoctorCardProps {
  index: number;
  doctor: IDoctor;
}

const DoctorCard = ({ index, doctor }: IDoctorCardProps) => {
  const { inView, ref } = useInView({
    threshold: 1,
    triggerOnce: true
  });
  const [nowDoctorFollowing, setNowDoctorFollowing] = useState<boolean>(
    doctor.following
  );

  useEffect(() => {
    if (inView) {
      sendShow('RECOMMEND_DOCTOR_LIST', {
        doctor_id: `${doctor.doctorId}`,
        index: `${index + 1}`
      });
    }
  }, [inView]);

  const handleOpen = (doctorId: number, buttonName: string) => {
    if (isInApp) {
      const kUrl = `kwai://profile/${doctorId}`;
      openOrDownload(kUrl);
    }
    sendClick('RECOMMEND_DOCTOR_LIST', {
      doctor_id: `${doctorId}`,
      index: `${index + 1}`,
      button_name: buttonName
    });
  };

  const handleFollow = (doctorId: number, buttonName: string) => {
    toLogin(
      () => {
        ksBridge.requestFollowUserV2({
          userId: doctorId,
          following: true,
          activityId: 'healthy',
          success: (res) => {
            if (res?.result === -1) {
              Toast.show('关注失败，请升级最新版 APP');
              return;
            }
            Toast.show(`关注成功`);
            setNowDoctorFollowing(true);
          },
          fail: (err) => {
            // Sentry 已移除，此调用已注释
            console.log(
              '[Sentry Mock] follow doctor error:',
              new Error(JSON.stringify(err))
            );
            Toast.show(`关注失败`);
          }
        });
      },
      () => {
        // do nothing
      }
    );
    sendClick('RECOMMEND_DOCTOR_LIST', {
      doctor_id: `${doctorId}`,
      index: `${index + 1}`,
      button_name: buttonName
    });
  };

  return (
    <li
      ref={ref}
      key={index}
      className={styles['doctor-card']}
      role="presentation"
      onClick={() => handleOpen(doctor.doctorId, 'HEAD')}
    >
      <WebImage url={doctor.doctorPhoto} />
      <h1>{doctor.nickName}</h1>
      <p className={styles['auth-info']}>{doctor.authInfo}</p>
      <div
        className={styles['follow-button']}
        role="presentation"
        onClick={(e) => {
          e.stopPropagation();
          if (nowDoctorFollowing) {
            handleOpen(doctor.doctorId, 'HEAD');
          } else {
            handleFollow(doctor.doctorId, 'FOLLOW');
          }
        }}
      >
        <p>{nowDoctorFollowing ? '已关注' : '关注'}</p>
      </div>
    </li>
  );
};

export default DoctorCard;
